export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/node_modules/d3-geo/src/identity.js
// module id = ../../../../d3-geo/src/identity.js
// module chunks = common